export { default } from './Position'

export const positions = [
	{ id: 0, text: 'Hygienist' },
	{ id: 1, text: 'Dental Assistant' },
	{ id: 2, text: 'Admin/Front Desk' },
	{ id: 3, text: 'Associate Dentist' },
]

export const basis = [
	{ id: 1, text: 'Permanent' },
	{ id: 2, text: 'Maternity Leave' },
	{ id: 3, text: 'Contract' },
]

export type Select = {
	id: number;
	text: string;
};
